import React, { useState } from 'react';
import {
  Card,
  Table,
  Tag,
  Typography,
  Row,
  Col,
  Statistic,
  Collapse,
  List,
  Avatar,
  Badge,
  Space,
  Input,
  Select,
} from 'antd';
import {
  SafetyOutlined,
  UserOutlined,
  TeamOutlined,
  CrownOutlined,
  BookOutlined,
  BarChartOutlined,
  SettingOutlined,
  DollarOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { Permission, PermissionCategory, PermissionAction } from '../types';
import { mockPermissions, mockUserRoles } from '../data/mockData';
import { PERMISSION_CATEGORIES, PERMISSION_ACTIONS } from '../constants';

const { Text, Title } = Typography;
const { Panel } = Collapse;
const { Search } = Input;
const { Option } = Select;

const PermissionsTab: React.FC = () => {
  const [searchText, setSearchText] = useState('');
  const [categoryFilter, setCategoryFilter] = useState<PermissionCategory | 'all'>('all');
  const [actionFilter, setActionFilter] = useState<PermissionAction | 'all'>('all');

  // Statistics
  const totalPermissions = mockPermissions.length;
  const readPermissions = mockPermissions.filter(p => p.action === 'read').length;
  const writePermissions = mockPermissions.filter(p => p.action === 'write').length;
  const adminPermissions = mockPermissions.filter(p => p.action === 'admin').length;

  return (
    <div>
      {/* Statistics Cards */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="Total Permissions"
              value={totalPermissions}
              prefix={<SafetyOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Read Permissions"
              value={readPermissions}
              prefix={<SafetyOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Write Permissions"
              value={writePermissions}
              prefix={<SafetyOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Admin Permissions"
              value={adminPermissions}
              prefix={<SafetyOutlined />}
              valueStyle={{ color: '#f5222d' }}
            />
          </Card>
        </Col>
      </Row>

      <Card>
        <Text>Permissions management functionality will be implemented here.</Text>
      </Card>
    </div>
  );
};

export default PermissionsTab; 